var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { observe } from "mobx";
var StakeInput = /** @class */ (function (_super) {
    __extends(StakeInput, _super);
    function StakeInput(props) {
        var _this = _super.call(this, props) || this;
        _this.getInputValue = function (e) {
            var procValue = _this.props.inputHandler(e.target.value);
            _this.setState({
                value: procValue
            }, function () {
                _this.props.handler(_this.state.value);
            });
        };
        _this.state = {
            value: props.provider.stakeValue
        };
        _this.disposeValue = observe(_this.props.provider, "stakeValue", function (o) {
            _this.setState({
                value: o.newValue
            });
        });
        return _this;
    }
    StakeInput.prototype.componentWillUnmount = function () {
        this.disposeValue();
    };
    StakeInput.prototype.render = function () {
        return (React.createElement("input", { type: this.props.type, className: "rj-yourbet__stake-input", "data-uat": "rj-yourbet-stake-input", value: this.state.value, onChange: this.getInputValue }));
    };
    return StakeInput;
}(React.Component));
export { StakeInput };
//# sourceMappingURL=StakeInput.js.map